/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesStoreGetPaymentStatusRequest interface.
 */
export function instanceOfFxIdWebFeaturesStoreGetPaymentStatusRequest(value) {
    if (!('PaymentId' in value) || value['PaymentId'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreGetPaymentStatusRequestFromJSON(json) {
    return FxIdWebFeaturesStoreGetPaymentStatusRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreGetPaymentStatusRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'PaymentId': json['PaymentId'],
    };
}
export function FxIdWebFeaturesStoreGetPaymentStatusRequestToJSON(json) {
    return FxIdWebFeaturesStoreGetPaymentStatusRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreGetPaymentStatusRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'PaymentId': value['PaymentId'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreGetPaymentStatusRequest.js.map